import {useMemo, useState} from 'react';
import {searchCatalog} from '../../../components/offerCatalogSearch';
import {useProductCatalogWithStocks} from './use-product-catalog-with-stocks';

export function useProductsPage() {
	const catalogState = useProductCatalogWithStocks();
	const [query, setQuery] = useState('');

	const filtered = useMemo(() => {
		if (!catalogState.catalog) return [];
		const items = searchCatalog(catalogState.catalog, query, 500);
		const {stockByOfferId} = catalogState;
		return [...items].sort((left, right) => {
			const leftStock = stockByOfferId.get(left.offerId) ?? -1;
			const rightStock = stockByOfferId.get(right.offerId) ?? -1;
			if (rightStock !== leftStock) return rightStock - leftStock;
			return left.name.localeCompare(right.name, 'ru');
		});
	}, [catalogState, query]);

	return {
		...catalogState,
		filtered,
		query,
		setQuery,
	};
}
